export default "__VITE_ASSET__BdWgOOY5__"